import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";
import { PoolModel } from "../models/pool";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router
  ) {}

  private pools: PoolModel[];
  private poolActive: PoolModel;

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  async getPools() {
    if (this.pools) return Promise.resolve(this.pools);
    const pools = await this.http
      .get<any>(environment.BASE_API_URL + CONSTANTS.API.COMMON.POOL, {
        headers: this.headers.headers,
        params: { isWebApp: "true" },
      })
      .toPromise()
      .then((r) => r)
      .catch(() => []);
    this.pools = pools;
    if (!this.poolActive && pools[0]) this.poolActive = pools[0];
    return pools;
  }

  async getPoolsV2(isWebApp: true, permission: number) {
    const pools = await this.http
      .get<any>(environment.BASE_API_URL + CONSTANTS.API.COMMON.POOL_V2, {
        headers: this.headers.headers,
        params: {
          isWebApp: isWebApp.toString(),
          permission: permission.toString(),
        },
      })
      .toPromise()
      .then((r) => r.result)
      .catch(() => []);
    this.pools = pools;
    if (!this.poolActive && pools[0]) this.poolActive = pools[0];
    return pools;
  }

  getPoolActive() {
    return this.poolActive;
  }

  setPoolActive(pool: PoolModel) {
    this.poolActive = pool;
    return pool;
  }

  getPoolsFleet() {
    return this.http.get<any>(
      environment.BASE_API_URL + CONSTANTS.API.COMMON.POOL_FLEET,
      this.headers
    );
  }

  getEntitledPools() {
    return this.http.get<any>(
      environment.BASE_API_URL + CONSTANTS.API.COMMON.ENTITLED_POOLS,
      { headers: this.headers.headers, params: { isWebApp: "true" } }
    );
  }

  checkActiveRoute(nav) {
    if (!nav?.isShow) {
      this.router.navigate(["/404"]);
    }
  }
}
